<template>
  <div class="row">
    <div class="col-12" v-if="list.length">
        <div class="card" style="border: 2px solid red">
            <div class="card-header">
                <h4>عمليات ارسال الواتس التلقائي</h4>
            </div>
            <div class="card-body table-responsive" style="min-height: auto !important">
                <table class="table table-hover table-striped">
                    <thead>
                        <th>
                            ID
                        </th>
                        <th>
                            العدد الاجمالي
                        </th>
                        <th>
                            المتبقي
                        </th>
                        <th>
                            الحالة
                        </th>
                        <th>
                            آخر رسالة
                        </th>
                        <th>
                            خيارات
                        </th>
                    </thead>
                    <tbody>
                        <tr v-for="(p, index) in list" :key="index * 2">
                            <td>
                                {{ p.id }}
                            </td>
                            <td>
                                {{ new Intl.NumberFormat().format(p.numbers_left.length + p.numbers_sent.length) }}
                            </td>
                            <td>
                                <strong>
                                    {{ new Intl.NumberFormat().format(p.numbers_left.length) }}
                                </strong>
                                <div class="progress">
                                    <div class="progress-bar" style="background: green;" role="progressbar" :style="`width: ${((p.numbers_sent.length) / (p.numbers_sent.length + p.numbers_left.length)) * 100}%`" :aria-valuenow="((p.numbers_sent.length) / (p.numbers_sent.length + p.numbers_left.length)) * 100" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </td>
                            <td>
                                <span v-if="p.status == 0" class="badge bg-warning btn-sm">
                                    <i class="fa fa-clock-o"></i>
                                    في الانتظار
                                </span>
                                <span v-if="p.status == 1" class="badge bg-primary btn-sm">
                                    <i class="fa fa-clock-o"></i>
                                    جاري الإرسال
                                </span>
                                <span v-if="p.status == 2" class="badge bg-danger btn-sm">
                                    <i class="fa fa-clock-o"></i>
                                    متوقف
                                </span>
                                <span v-if="p.status == 3" class="badge bg-success btn-sm">
                                    <i class="fa fa-check"></i>
                                    انتهت العملية
                                </span>
                            </td>
                            <td v-html="p.last_message">
                            </td>
                            <td>
                                <b-dropdown
                                    id="dropdown-1"
                                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                    text="خيارات"
                                    variant="primary"
                                    size="sm"
                                >
                                    <b-dropdown-item @click="startOperation(p._id)" v-if="p.status != 1 && p.status != 3">
                                        <span class="text-success">
                                            <i class="fa fa-check"></i>
                                            تشغيل
                                        </span>
                                    </b-dropdown-item>
                                    <b-dropdown-item class="text-danger" @click="stopOperation(p._id)" v-if="p.status == 1 && p.status != 3">
                                        <span class="text-danger">
                                            <i class="fa fa-times"></i>
                                            ايقاف
                                        </span>
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="deleteOperation(p._id)">
                                        <i class="fa fa-trash"></i>
                                        حذف
                                    </b-dropdown-item>
                                </b-dropdown>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="col-12 text-center g" v-if="loading">
                    <img
                    :src="require('@/assets/images/loading.svg')"
                    style="width: 150px; height: 150px"
                    alt=""
                    />
                    <br><br>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 col-lg-8 c g">
        <div class="card">
            <div class="card-body">
                <div class="form-group">
                  <h5 for="">الرسالة <a href="javascript:;" @click="templates('asd43345')"><u><i class="fa fa-comment"></i> قوالب الرسائل</u></a></h5>
                  <textarea class="form-control asd43345" v-model="message" rows="5" placeholder="اكتب الرسالة هنا..."></textarea>
                </div>
                <div class="form-group">
                  <label for="">ارفاق ملف</label>
                  <input type="file"
                    class="form-control" id="ingredient_file" accept=".png,.jpeg,.jpg,.pdf,.docx,.doc,.xls,.xlsx" @change="uploadImage()">
                    <strong v-if="loading" id="helpId" class="form-text text-success">
                        <img :src="require('@/assets/images/loading.svg')" style="width: 20px;" alt=""> جاري الرفع...
                    </strong>
                </div>
                <div class="g">
                    <div class="border g">
                        <small>المتغيرات في الرسالة</small>
                        <br>
                        اسم الطالب: {name} <br> رابط الملف: {link}
                        <br>
                        الصف: {classname} <br> الفصل: {classroom}
                        <br>
                        رابط تحميل تطبيق ولي الامر للاندرويد: <input type="text" style="border:none; width: 300px" readonly value="http://gl.sa/cX6Jt">
                        <br>
                        رابط تحميل تطبيق ولي الامر للايفون: <input type="text" style="border:none; width: 300px" readonly value="http://gl.sa/hFfwF">
                        <br>
                        <button class="btn btn-sm btn-outline-primary" @click="copy(); donecopy = true">
                            <i class="fa fa-copy"></i>
                            {{ donecopy ? 'تم النسخ' :  'نسخ المتغيرات' }}
                        </button>&nbsp;
                        <button class="btn btn-sm btn-outline-success" @click="insert()">
                            <i class="fa fa-arrow-up"></i>
                            اضافة للرسالة
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <div v-if="!way">
                    <p>اختر المراد الارسال لهم</p>
                    <div class="row">
                        <div class="col-12 col-lg-6 g">
                            <button class="btn btn-block btn-primary" @click="way = 'single'">
                                <i class="fa fa-users"></i>
                                اختر فردياً
                            </button>
                        </div>
                        <div class="col-12 col-lg-6 g">
                            <button class="btn btn-block btn-success" @click="way = 'bulk'">
                                <i class="fa fa-users"></i>
                                اختر من الفصول
                            </button>
                        </div>
                        <div class="col-12 col-lg-6 g">
                            <button class="btn btn-block btn-info" @click=" getReport(); way = 'attend';">
                                <i class="fa fa-check"></i>
                                الحاضرين اليوم
                            </button>
                        </div>
                        <div class="col-12 col-lg-6 g">
                            <button class="btn btn-block btn-warning" @click="getNoApp(); way = 'no_app';">
                                <i class="fa fa-mobile"></i>
                                من لم يحمل التطبيق
                            </button>
                        </div>
                    </div>
                </div>
                <div v-if="way == 'single' || way == 'attend' || way == 'no_app'">
                    <div class="g">
                        اختر الطلاب <input type="text" placeholder="ابحث هنا..." v-model="q" @change="getStudents()" @keyup="getStudents()" style="border: none; border: 1px solid #999; padding: 5px"> <button class="btn btn-sm"><i class="fa fa-search"></i> بحث</button>
                    </div>
                    <div style="width: 100%; border: solid 2px #333; padding: 5px; overflow-y: scroll; height: 150px;">
                        <div class="form-check" v-for="student in students" :key="student._id">
                        <label class="form-check-label">
                            <input type="checkbox" class="form-check-input" v-model="selected" :value="student">
                            {{ student.name }}
                        </label>
                        </div>
                    </div>
                </div>
                <div v-if="way == 'bulk'">
                    <div>
                        اختر الفصول <a href="javascript:;" @click="xxxc()">
                            <i class="fa fa-check-square"></i>
                            اختيار الكل
                        </a>
                        <br><br>
                    </div>
                    <div class="form-check" v-for="c in classrooms" :key="c">
                        <label class="form-check-label">
                            <input type="checkbox" class="form-check-input ascddsd" @change="classChanges(c)" v-model="selected_classrooms" :value="c">
                            {{ c }}
                        </label>
                        <div class="card-body">
                            <div class="border g" style="overflow-y: scroll; height: 100px">
                                <template v-for="student in students">
                                    <div v-if="student.classname + ' - ' + student.classroom == c" class="form-check" :key="student._id">
                                        <label class="form-check-label">
                                            <input type="checkbox" class="form-check-input" v-model="selected" :value="student">
                                            {{ student.name }}
                                        </label>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <b-modal id="sendWhatsapp" title="ارسال عبر الواتس التلقائي" hide-footer>
                <h5 class="alert alert-danger g text-center">
                    <img :src="require('@/assets/images/slow_send.png')" alt="" style="width: 80px;"><br><br>
                   <span class="text-dark">
                     سيتم ارسال الرسائل الجماعية عبر الإرسال البطيئ (رسالة كل دقيقة)<br><br>
                     لتجنب حظر رقمكم من الواتسآب.
                   </span>
                </h5>
                <div class="col-12 text-center g">
                    <button class="btn btn-primary" @click="send('whatsapp')">
                        بدء الإرسال الآن
                        <i class="fa fa-arrow-left"></i>
                    </button>
                <br><br>
                الوقت المتوقع لإنتهاء الإرسال: <strong class="text-primary">{{ convertToArabicTime(selected.length) }}</strong>
                </div>
            </b-modal>
            <div class="card-footer" v-if="way && selected.length > 0">
                <div class="row">
                    <div class="col-12 col-lg-6 g">
                        <b-dropdown style="width: 100%"
                            id="dropdown-1" dropup size="lg"
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="success"
                        >
                            <template #button-content>
                                <i class="fa fa-whatsapp"></i>
                                واتساب
                            </template>
                            <b-dropdown-item v-b-modal.sendWhatsapp style="border-bottom: solid 1px #ddd">
                                <span style="font-size: 18"><img :src="require('@/assets/images/whats-1.png')" style="width: 28px;">
                                واتساب تلقائي (الواتس الذكي)</span>
                            </b-dropdown-item>
                            <b-dropdown-item  @click="send('wa')" style="border-bottom: solid 1px #ddd">
                                <span style="font-size: 18"><img :src="require('@/assets/images/whats-2.png')" style="width: 28px;">
                                 اداة المتصفح المجانية</span>
                            </b-dropdown-item>
                            <b-dropdown-item  @click="send('xwa')" style="border-bottom: solid 1px #ddd">
                                <span style="font-size: 18"><img :src="require('@/assets/images/whats-3.png')" style="width: 28px;">
                                الاداة المتطورة (الواتس المباشر) <i class="btn btn-danger" style="padding: 2px">جديد</i></span>
                            </b-dropdown-item>
                            <div class="text-center g">
                                <a href="/whats-methods" target="_blank">ما الفرق بينهم؟</a>
                            </div>
                        </b-dropdown>
                    </div>
                    <div class="col-12 col-lg-6 g">
                        <button class="btn btn-primary btn-block btn-lg"  @click="send('sms')">
                            <i class="fa fa-mobile"></i>
                            SMS
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive";
import { VBModal, BModal, BFormInput, BDropdown, BDropdownItem } from "bootstrap-vue";
export default {
    components: {
        // Layouts
        BDropdown, BDropdownItem,
        BModal,BFormInput},
    directives: {
        Ripple,
        "b-modal": VBModal,
    },
    data(){
        return {
            message: "",
            loading: false,
            file: null,
            list: [],
            user: JSON.parse(localStorage.getItem('user')),
            way: false,
            students: [],
            classrooms: [],
            q: null,
            selected: [],
            selected_classrooms: [],
            donecopy: false
        }
    },
    created(){
        if(!checkPer("students|students|send")){
            this.$router.push('/NotPermitted')
            return false;
        }
        this.getList()
        var g = this;
        g.getStudents()
    },
    methods: {
        convertToArabicTime: function(totalMinutes) {
            const hours = Math.floor(totalMinutes / 60);
            const minutes = totalMinutes % 60;

            const getArabicHours = (h) => {
                if (h === 0) return "";
                if (h === 1) return "ساعة";
                if (h === 2) return "ساعتان";
                if (h >= 3 && h <= 10) return `${h} ساعات`;
                return `${h} ساعة`;
            };

            const getArabicMinutes = (m) => {
                if (m === 0) return "";
                if (m === 1) return "دقيقة";
                if (m === 2) return "دقيقتان";
                if (m >= 3 && m <= 10) return `${m} دقائق`;
                return `${m} دقيقة`;
            };

            const hoursPart = getArabicHours(hours);
            const minutesPart = getArabicMinutes(minutes);

            if (hoursPart && minutesPart) {
                return `${hoursPart} و ${minutesPart}`;
            }
            return hoursPart || minutesPart || "صفر دقيقة";
            },
        xxxc(){
            $(".ascddsd").each(function(){
                $(this).click()
            })
        },  
        getStudents(){
            var g = this;
            $.post(api + '/user/students/list', {
                jwt: this.user.jwt,
                q: this.q,
                page: 1,
                perpage: 10000
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    g.students = r.response
                    g.students.forEach(function(a){
                        if(!g.classrooms.includes(a.classname + ' - ' + a.classroom)){
                            g.classrooms.push(a.classname + ' - ' + a.classroom)
                        }
                    })
                }
            }).fail(function(){
                g.loading = false;
            })
        },
        templates(x){
            $("#templates").click()
            $("#inserttemplateto").val(x)
        },
        classChanges(cc){
            var g = this;
            g.students.forEach(function(a){
                if(g.selected_classrooms.includes(a.classname + ' - ' + a.classroom) && cc == a.classname + ' - ' + a.classroom){
                    g.selected.push(a)
                }
                if(!g.selected_classrooms.includes(a.classname + ' - ' + a.classroom)){
                    g.selected = g.selected.filter(function(x){
                        if(!g.selected_classrooms.includes(x.classname + ' - ' + x.classroom)){
                            return false;
                        }else{
                            return x;
                        }
                    })
                }
            })
        },
        copy(){
            navigator.clipboard.writeText(`اسم الطالب: {name}
رابط الملف: {link}
الصف: {classname}
الفصل: {classroom}
رابط تحميل تطبيق ولي الامر للاندرويد: 
http://gl.sa/YLWQY
رابط تحميل تطبيق ولي الامر للايفون: 
http://gl.sa/jJ35q`);
        },
        insert(){
            this.message = (`اسم الطالب: {name}
رابط الملف: {link}
الصف: {classname}
الفصل: {classroom}
رابط تحميل تطبيق ولي الامر للاندرويد: 
http://gl.sa/YLWQY
رابط تحميل تطبيق ولي الامر للايفون: 
http://gl.sa/jJ35q`);
        },
        send(method){
            var g = this;
            var messages = [];
            g.selected.forEach(function(a){
                messages.push({
                    phones: a.phones,
                    message: convertToHijri(g.message.replace("{name}", a.name).replace("{classname}", a.classname).replace("{classroom}", a.classroom).replace("{link}", `({${g.file}})`))
                })
            })
            if(g.file && messages[0]?.message?.includes("({")){
                $.post(api + '/user/general/short-links', {
                    jwt: this.user.jwt,
                    arr: JSON.stringify(messages),
                }).then(function(rx){
                    if(method == 'wa'){
                        $("#sendmodalwaarray").val(JSON.stringify(rx.response))
                        $("#sendmodalwatype").val("students")
                        $("#sendWAModal").click()
                        $(".x345").removeClass('btn-success')
                        $(".x345").addClass('btn-outline-danger')
                        $(".x345").html("<i class='fa fa-refresh'></i> حدث الصفحة للارسال من الاداة مرة أخرى")
                    }else{
                        if(method == 'whatsapp'){
                            $.post(api + '/user/messages/send-operation', {
                                jwt: g.user.jwt,
                                arr: JSON.stringify(rx.response),
                                method: method,
                                type: "students"
                            }).then(function(r){
                                g.loaded = true;
                                if(r.status != 100){
                                    alert(r.response, 200)
                                }else{
                                    location.reload()
                                }
                            }).fail(function(){
                                alert("حدث خطأ", 200)
                            })
                        }else{
                            if(!confirm(`متأكد من ارسال ${messages.length} رسالة؟`)){return false;}
                            $.post(api + '/user/messages/send-arr', {
                                jwt: g.user.jwt,
                                arr: JSON.stringify(rx.response),
                                method: method,
                                type: "students"
                            }).then(function(r){
                                g.loaded = true;
                                if(r.status != 100){
                                    alert(r.response, 200)
                                }else{
                                    alert("تم الارسال بنجاح٫ يمكنك تصفح ارشيف الرسائل", 100)
                                }
                            }).fail(function(){
                                alert("حدث خطأ", 200)
                            })
                        }
                    }
                }).fail(function(){
                        alert("حدث خطأ.", 200)
                    })
            }else{
                if(method == 'wa'){
                    $("#sendmodalwaarray").val(JSON.stringify(messages))
                    $("#sendmodalwatype").val("students")
                    $("#sendWAModal").click()
                        $(".x345").removeClass('btn-success')
                        $(".x345").addClass('btn-outline-danger')
                        $(".x345").html("<i class='fa fa-refresh'></i> حدث الصفحة للارسال من الاداة مرة أخرى")
                }else{
                     if(method == 'whatsapp'){
                        $.post(api + '/user/messages/send-operation', {
                            jwt: g.user.jwt,
                            arr: JSON.stringify(messages),
                            method: method,
                            type: "students"
                        }).then(function(r){
                            g.loaded = true;
                            if(r.status != 100){
                                alert(r.response, 200)
                            }else{
                                location.reload()
                            }
                        }).fail(function(){
                            alert("حدث خطأ", 200)
                        })
                    }else{
                        $.post(api + '/user/messages/send-arr', {
                            jwt: g.user.jwt,
                            arr: JSON.stringify(messages),
                            method: method,
                            type: "students"
                        }).then(function(r){
                            g.loaded = true;
                            if(r.status != 100){
                                alert(r.response, 200)
                            }else{
                                alert("تم الارسال بنجاح٫ يمكنك تصفح ارشيف الرسائل", 100)
                            }
                        }).fail(function(){
                            alert("حدث خطأ", 200)
                        })
                    }
                }
            }
        },
        getNoApp(){
            var g = this;
            g.selected = [];
            g.students.forEach(function(a){
                if(!a.fcm || a.fcm == ''){
                    g.selected.push(a)
                }
            })
        },
        getReport(){
            var g = this;
            $.post(api + '/user/students/reports/daily', {
                jwt: this.user.jwt,
                date: new Date().toISOString().split('T')[0],
                classname: null,
                status: null,
                q: null
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    var arr = r.response.map(function(x){
                        if(x.status == "1" || x.status == "2"){
                            return x.number;
                        }else{
                            return false;
                        }
                    }).filter(function(x){
                        return x;
                    })
                    g.students.forEach(function(a){
                        if(arr.includes(a.number)){
                            g.selected.push(a)
                        }
                    })
                }
            }).fail(function(){
                setTimeout(function(){
                    g.getReport()
                }, 500)
            })  
        },

        getList(){
            var g = this;
            $.post(api + "/user/messages/operations/list", {
            jwt: this.user.jwt,
            }).then(function(a){
                g.list = a.response
                g.loading = false
                setTimeout(() => {
                    g.getList()
                }, 5000);
            }).catch(function(){
                setTimeout(() => {
                    g.getList()
                }, 5000);
                g.loading = false
            })
        },
        startOperation(id){
            var g =this;
            $.post(api + "/user/messages/operations/status", {
            jwt: this.user.jwt,
            id: id,
            status: 1
            }).then(function(a){
                location.reload()
            })
        },
        stopOperation(id){
            var g =this;
            $.post(api + "/user/messages/operations/status", {
            jwt: this.user.jwt,
            id: id,
            status: 2
            }).then(function(a){
                location.reload()
            })
        },
        deleteOperation(id){
            if(confirm('متأكد من الحذف؟')){
                var g =this;
                $.post(api + "/user/messages/operations/delete", {
                jwt: this.user.jwt,
                id: id
                }).then(function(a){
                    location.reload()
                })
            }
        },
        uploadImage(){
            var g = this;
            g.loading = true;
            var Upload = function (file) {
                this.file = file;
            };

            Upload.prototype.getType = function () {
                return this.file.type;
            };
            Upload.prototype.getSize = function () {
                return this.file.size;
            };
            Upload.prototype.getName = function () {
                return this.file.name;
            };
            Upload.prototype.doUpload = function () {
                var that = this;
                var formData = new FormData();

                // add assoc key values, this will be posts values
                formData.append("file", this.file, this.getName());
                formData.append("jwt", g.user.jwt);

                $.ajax({
                type: "POST",
                url: api + '/user/general/upload',
                xhr: function () {
                    var myXhr = $.ajaxSettings.xhr();
                    if (myXhr.upload) {
                    myXhr.upload.addEventListener(
                        "progress",
                        that.progressHandling,
                        false
                    );
                    }
                    return myXhr;
                },
                success: function (data) {
                    g.loading = false;
                    // your callback here
                    if(data.status != 100){
                        alert("هذا الملف غير غير", 200)
                        return;
                    }
                    g.file = data.response
                    if(!g.message.includes("{link}")){
                    g.message = g.message + '\nرابط الملف: {link}'
                    }
                },
                error: function (error) {
                    // handle error
                    alert("حدث خطأ");
                },
                async: true,
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                timeout: 60000,
                });
            };
            var file = $("#ingredient_file")[0].files[0];
            var upload = new Upload(file);
            upload.doUpload();
        }
    }
}
</script>

<style>
.dropdown-menu.show{
    border: solid 2px #999
}
</style>